import React from 'react';
import { connect } from 'react-redux';

import { makeGetUpgradeCtaData } from '../redux';
import { getPageLabels } from 'src/universal/redux/page';

import styles from '../__styles__/ctas.scss?modules';

const AdditionalUpgradeText = ({ upgradeCtaData, labels }) => {
  const { needUpgradeCta } = upgradeCtaData;
  const { upgradeCtaDescription } = labels;
  if (!needUpgradeCta) {
    return null;
  }

  return <span className={styles.upgradeText}>{upgradeCtaDescription}</span>;
};

const mapStateToProps = () => {
  const getUpgradeCtaData = makeGetUpgradeCtaData();

  return (state, { shortName }) => ({
    upgradeCtaData: getUpgradeCtaData(state, shortName),
    labels: getPageLabels(state)
  });
};

export default connect(mapStateToProps)(AdditionalUpgradeText);
